import { cn } from '@eliadmin/core/src/utils/style-utils';

export const Heading = ({
  subtitle,
  title,
  className,
  as: Tag = 'h2',
}: {
  subtitle?: string;
  title: string;
  as?: 'h1' | 'h2' | 'h3';
  className?: {
    container?: string;
    subtitle?: string;
    title?: string;
  };
}) => {
  return (
    <div className={cn('flex w-full flex-col gap-3', className?.container)}>
      {subtitle && (
        <p className={cn('text-sm font-medium text-primary sm:text-base', className?.subtitle)}>
          {subtitle}
        </p>
      )}
      <Tag
        className={cn(
          'font-heading',
          'text-3xl font-normal text-black sm:text-4xl',
          className?.title,
        )}
      >
        {title}
      </Tag>
    </div>
  );
};
